export default class Log {

  id = '';

  constructor() {
  }
}